import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import StandardDialog from 'components/common/standard_dialog'
import {
  DESCRIPTION_ROWS,
  CROWDFUNDING_DESCRIPTION_LENGTH,
} from 'shared/lengths'
import styles from './post_update_cf.less'
import { domOnlyProps } from 'lib/form_utils'
import {
  TextInput,
  HeadingText,
  Button,
  TextArea,
  BodyText,
  CaptionText,
} from '@paypalcorp/pp-react'
import { getFormError } from 'lib/validators'
import { TOAST_NOTIFICATIONS } from 'shared/shared_consts'
import { Message } from '@paypalcorp/worldready-react'
import DeleteUpdateActivity from '../delete_organizer_update/delete_update_activity_container'
import { appendPath } from 'lib/route_utils'
import { trackFPTI } from 'lib/fpti_utils'
import { get } from 'lodash'

const i18n = getI18n('components/edit_glimpse/post_update')

class PostUpdate extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    showDelete: PropTypes.bool,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onSave: PropTypes.func,
    handleSubmit: PropTypes.func,
    router: PropTypes.object,
    campaign: PropTypes.object,
    stepRef: PropTypes.func,
    dirty: PropTypes.bool,
    onToggleToast: PropTypes.func,
    organizerUpdateId: PropTypes.string,
    resetError: PropTypes.func,
    campaignId: PropTypes.string,
    campaignError: PropTypes.object,
    errors: PropTypes.object,
  }

  state = {
    isOpen: false,
    editedCampagin: this.props.campaign,
    showBackDialog: false,
    callback: null,
    showDeleteDialog: false,
  }

  handleSubmit = () => {
    trackFPTI(
      this.props.campaign,
      'click',
      'dw_giving_post_update_quit_finish_update_pressed'
    )
    this.setState({ showBackDialog: false, callback: null })
    const request = {
      subject: this.props.fields.subject.value,
      text: this.props.fields.text.value,
    }
    return this.props
      .onSave(request, this.props.organizerUpdateId)
      .then(response => {
        if (this.props.organizerUpdateId) {
          this.props.onToggleToast(TOAST_NOTIFICATIONS.EDIT_SUCCESS)
          this.editBack()
          this.props.onToggleToast(
            TOAST_NOTIFICATIONS.EDIT_SUCCESS,
            i18n('edit_notification')
          )
        } else {
          this.goToSharePage(response)
        }
        trackFPTI(
          this.props.campaign,
          'ac',
          'dw_giving_update_post_success_occurred'
        )
      })
      .catch(err => {
        this.props.router.push({
          pathname: appendPath(location.pathname, 'error'),
          state: { error: err },
        })
      })
  }

  componentDidMount() {
    if (this.props.stepRef) {
      this.props.stepRef(this)
    }
    if (this.props.organizerUpdateId) {
      trackFPTI(
        this.props.campaign,
        'impression',
        'dw_giving_edit_update_screen_shown'
      )
    } else {
      trackFPTI(
        this.props.campaign,
        'impression',
        'dw_giving_create_update_screen_shown'
      )
    }
  }

  goToSharePage = updateData => {
    const pathname = appendPath(location.pathname, `${updateData.fou_id}/share`)
    this.props.router.push({
      pathname,
      state: { updateData },
    })
  }

  editBack = params => {
    const { params: { hideBack = false } = {} } = this.props.router
    if (hideBack || params?.hideBack) {
      this.props.router.push({
        pathname: '/pools',
        state: { campaignId: this.props.campaignId },
      })
    } else {
      this.props.router.goBack()
    }
  }

  handleDialogClose = () => {
    this.setState({ showBackDialog: false })
    trackFPTI(
      this.props.campaign,
      'click',
      'dw_giving_post_update_quit_dismiss_pressed',
      'close'
    )
  }

  confirmNavigation = callback => {
    if (this.props.dirty) {
      this.setState({ showBackDialog: true, callback })
      trackFPTI(
        this.props.campaign,
        'impression',
        'dw_giving_post_update_quit_screen_shown'
      )
    } else {
      if (this.props.organizerUpdateId) {
        trackFPTI(
          this.props.campaign,
          'click',
          'dw_giving_edit_update_dismiss_pressed',
          'close'
        )
      } else {
        trackFPTI(
          this.props.campaign,
          'click',
          'dw_giving_create_update_dismiss_pressed',
          'close'
        )
      }
      this.editBack()
    }
  }

  handleQuit = () => {
    trackFPTI(
      this.props.campaign,
      'click',
      'dw_giving_post_update_quit_cancel_pressed',
      'close'
    )
    this.editBack()
  }
  render() {
    const {
      fields: { subject, text },
      handleSubmit,
      showDelete,
      organizerUpdateId,
      campaign,
    } = this.props
    const description = get(this.props, 'values.text', '')
    if (description.length > CROWDFUNDING_DESCRIPTION_LENGTH) {
      const error = {
        error_desc: `exceed_max_${CROWDFUNDING_DESCRIPTION_LENGTH}_characters`,
        error_code: 'MATCH',
      }
      trackFPTI(
        campaign,
        'ac',
        'dw_giving_post_update_form_error_occurred',
        '',
        error
      )
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
        {this.state.showBackDialog && (
          <StandardDialog
            size="medium"
            title={
              showDelete
                ? i18n('dirty_dialog_title_cf')
                : i18n('dirty_dialog_create_title_cf')
            }
            subtitle={
              showDelete
                ? i18n('dirty_dialog_subtitle_cf')
                : i18n('dirty_dialog_create_subtitle_cf')
            }
            closeButtonTitle={
              showDelete ? i18n('quit_editing') : i18n('cancel')
            }
            okButtonTitle={
              showDelete ? i18n('save_changes') : i18n('finish_creating_update')
            }
            onClose={this.handleDialogClose}
            onOk={() => {
              const { text: errorText, subject: errorSubject } =
                this.props.errors || {}
              if (errorText || errorSubject) {
                this.setState({ showBackDialog: false })
              } else {
                this.handleSubmit()
              }
            }}
            onQuit={this.handleQuit}
            data-testid="edit-update"
            iconName="logout"
          />
        )}
        <HeadingText size="sm" styleName="title">
          {showDelete ? (
            <Message id="components.edit_glimpse.post_update.edit_title" />
          ) : (
            <Message id="components.edit_glimpse.post_update.create_title" />
          )}
        </HeadingText>
        <BodyText size="sm" styleName="subtitle">
          <Message id="components.edit_glimpse.post_update.subtitle" />
        </BodyText>
        <div styleName="textbox-wrapper" data-testid="subject">
          <TextInput
            id={subject.name}
            label={i18n('subject')}
            {...domOnlyProps(subject)}
            errorText={getFormError(subject)}
            data-testid="subject-textInput"
            auocomplete={false}
          />
        </div>
        <div styleName={'description-container'}>
          <div styleName="textbox-wrapper" data-testid="text">
            <TextArea
              {...domOnlyProps(text)}
              id={text.name}
              minRows={DESCRIPTION_ROWS}
              label={i18n('description')}
              showCharacterCounter={true}
              maxCharacters={CROWDFUNDING_DESCRIPTION_LENGTH}
              errorText={getFormError(text)}
              data-testid="text-textArea"
            />
          </div>
        </div>
        {showDelete ? (
          <DeleteUpdateActivity
            campaignId={this.props?.campaignId}
            id={this.props.organizerUpdateId}
            onClose={() => this.editBack({ hideBack: true })}
            campaign={this.props.campaign}
          />
        ) : (
          <CaptionText data-testid="max_update_fundraiser">
            <Message id="components.edit_glimpse.post_update.max_update_fundraiser" />
          </CaptionText>
        )}
        <Button
          size="lg"
          styleName="save-button"
          data-testid="save-button"
          onClick={() => {
            if (organizerUpdateId) {
              trackFPTI(campaign, 'click', 'dw_giving_edit_update_save_pressed')
            } else {
              trackFPTI(
                campaign,
                'click',
                'dw_giving_create_update_save_pressed'
              )
            }
          }}
        >
          <Message id="components.edit_glimpse.post_update.save_cf" />
        </Button>
      </form>
    )
  }
}

export default cssModules(PostUpdate, styles)
